import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

export const RecaptchaNoticeContainer = styled.div`
  margin-top: ${gridSize()}px;
`;
